import { createSelector } from 'reselect';
import _ from 'lodash';

import { USER_ROLES } from 'constants/index';
import { RootState } from '..';

export const selectUserData = (state: RootState) => {
  return state.client;
};

export const selectUserUID = createSelector(selectUserData, (client) => {
  return client.uid;
});

export const selectUserName = createSelector(selectUserData, (client) => {
  return client.name;
});

export const selectUserRoomRole = createSelector([selectUserData, (state, roomId) => roomId], (client, roomId) => {
  const userRoomRoleInfo = _.find(client.roomsRoles, { roomId });

  return userRoomRoleInfo?.role || USER_ROLES.LISTENER;
});

export const selectUserAuth = createSelector(selectUserData, (client) => {
  return client.auth;
});

export const selectIsLoggedIn = createSelector(selectUserAuth, (auth) => {
  return auth.isLoggedIn;
});
